<template>
  <div>
    <div class="yuliang" ref="yuliang">
      <div class="select">
        <span class="desc">起止日期:</span>
        <div class="block" style="display: inline-block;">
         <el-date-picker
            v-model="beginDate"
            type="month"
            :picker-options="Global.pickerOptionsStart(endDate)"
            value-format="yyyy-MM"
            placeholder="选择月"
            :clearable="false"
            :editable="false"
          ></el-date-picker>
          <span class="desc">至</span>
           <el-date-picker
            v-model="endDate"
            type="month"
            :picker-options="Global.pickerOptionsEnd(beginDate)"
            value-format="yyyy-MM"
            placeholder="选择月"
            :clearable="false"
            :editable="false"
          ></el-date-picker>
        </div>
        <span @click="monthselect" id="select">查询</span>
        <span @click="exportdata" id="export">
          <span class="export-icon"></span>导出
        </span>
      </div>
      <div class="raintable" ref="rttable">
        <ux-grid
          ref="plTable"
          :data="tdata"
          v-loading="loading"
          :max-height="height"
          border
          v-if="tableShow"
          style="width: 100%; text-align: center;"
          :sort-config="{defaultSort:{field: 'ljyl',order: 'desc'}}"
        >
          <ux-table-column fixed="left" type="index" width="60" title="序号" align="center" header-align="center">
          </ux-table-column>
          <ux-table-column fixed="left" field="addvnm" title="乡镇" align="center" sortable width="120"></ux-table-column>
          <ux-table-column fixed="left" field="stnm" title="站名" align="center" sortable width="150">
            <template slot-scope="scope">
              <el-tooltip effect="dark" :content="scope.row.stnm + ' ' + (scope.row.stcd?scope.row.stcd:'')" placement="top" class="item" popper-class="hiddenOverflow">
                <span style="cursor:pointer!important;" >{{ scope.row.stationName }}</span>
              </el-tooltip>
            </template>
          </ux-table-column>
            <ux-table-column
            fixed="left"
            field="ljyl"
            title="累计"
            sortable
            min-width="90"
            align="center"
            header-align="center"
            :sort-method="sortByljyl"
          >
            <!-- <template slot-scope="scope">
              <span>{{formatTableCellValue(scope.row['oldljyl'])}}</span>
            </template> -->
          </ux-table-column>
          <ux-table-column
            v-for="(item,index) in thedate"
            :key="index"
            :title="item"
            header-align="center"
          >
            <ux-table-column
              :field="item+'up'"
              title="上旬"
              sortable
              min-width="85"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                 {{scope.row[item +'up']===-1 ?'-':scope.row[item +'up']}}
                <!-- <span>{{formatTableCellValue(scope.row['old'+item+'up'])}}</span> -->
              </template>
            </ux-table-column>
            <ux-table-column
              :field="item+'middle'"
              title="中旬"
              sortable
              min-width="85"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                 {{scope.row[item +'middle']===-1 ?'-':scope.row[item +'middle']}}
                <!-- <span>{{formatTableCellValue(scope.row['old'+item+'middle'])}}</span> -->
              </template>
            </ux-table-column>
            <ux-table-column
              :field="item+'down'"
              title="下旬"
              sortable
              min-width="85"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                {{scope.row[item +'down']===-1 ?'-':scope.row[item +'down']}}
                <!-- <span>{{formatTableCellValue(scope.row['old'+item+'down'])}}</span> -->
              </template>
            </ux-table-column>
            <ux-table-column
              :field="item+'total'"
              title="月降雨"
              sortable
              min-width="95"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                 {{scope.row[item +'total']===-1 ?'-':scope.row[item +'total']}}
                <!-- <span>{{formatTableCellValue(scope.row['old'+item+'total'])}}</span> -->
              </template>
            </ux-table-column>
          </ux-table-column>
        </ux-grid>
      </div>
    </div>
    <el-dialog
      :title="thestation"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="30%">
      <div id="station"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import monitorTypes from '@/store/types/monitor'
export default {
  name: 'MonitoringCenter',
  data () {
    return {
      loading: true,
      height: 10,
      sID: '22',
      sTID: '',
      beginDate: '',
      endDate: '',
      stationName: '',
      isTown: true,
      searchName: '',
      tdata: [],
      all: true,
      adcdtotal: '',
      pageIndex: 1,
      pageSize: 100,
      towns: [],
      checkarr: [],
      datenum: '',
      thedate: [],
      dialogVisible: false,
      thestation: '',
      tableShow: true
    }
  },
  computed: {},
  methods: {
    sortByljyl (a, b) {
      if (a.ljyl !== undefined) {
        return a.ljyl - b.ljyl
      } else {
        return -1
      }
    },
    stationchart (data) {
      this.thestation = data
      this.dialogVisible = true
      this.drawChart()
    },
    tabledata () {
      this.loading = true
      this.$store
        .dispatch(monitorTypes.GET_MONTHLY_RAINFALL, {
          sID: this.sID,
          sTID: this.sTID,
          beginDate: this.beginDate,
          endDate: this.endDate,
          mainStation: true
        })
        .then(data => {
          this.tdata = []
          this.tableShow = false
          this.$nextTick(() => {
            this.tableShow = true
            this.$set(this, 'tdata', data.rows)
            this.tdata.forEach(item => {
              item['ljyl'] = item.total_str ? item.total : -1 // 解决排序问题
              // item['ljyl'] = this.getTableCellValue(item.total_str)
              // item['oldljyl'] = item.total_str
              item.data.forEach(element => {
                let date = element.date
                item[date + 'down'] = element.down_Str ? element.down : -1
                item[date + 'middle'] = element.middle_Str ? element.middle : -1
                item[date + 'up'] = element.up_Str ? element.up : -1
                item[date + 'total'] = element.total_Str ? element.total : -1
              // item[date + 'down'] = this.getTableCellValue(element.down_Str)
              // item['old' + date + 'down'] = element.down_Str
              // item[date + 'middle'] = this.getTableCellValue(
              //   element.middle_Str
              // )
              // item['old' + date + 'middle'] = element.middle_Str
              // item[date + 'up'] = this.getTableCellValue(element.up_Str)
              // item['old' + date + 'up'] = element.up_Str
              // item[date + 'total'] = this.getTableCellValue(element.total_Str)
              // item['old' + date + 'total'] = element.total_Str
              })
            })
          })
          // this.tdata = data.rows
          // this.$refs.plTable.reloadData(this.tdata) // umy-ui列表加载优化
          this.loading = false
        })
    },
    getTableCellValue: function (val) {
      let result = 0
      if (val !== undefined && val !== '') {
        result = Number(val)
      }
      return result
    },
    formatTableCellValue (val) {
      let result = val
      if (val === undefined || val === '') {
        result = '-'
      }
      return result
    },
    getdate: function () {
      let date = new Date()
      let formatDate = this.$options.filters['formatDate']
      this.endDate = `${formatDate(date, 'yyyy-MM')}`
      date = date.setMonth(date.getMonth() - 2)
      this.beginDate = `${formatDate(new Date(date), 'yyyy-MM')}`
    },
    monthselect: function () {
      this.loading = true
      let monthBetween = []
      let endDate = new Date(this.endDate)
      let beginDate = new Date(this.beginDate)
      let formatDate = this.$options.filters['formatDate']
      if (beginDate <= endDate) {
        monthBetween.push(`${formatDate(new Date(beginDate), 'yyyy-MM')}`)
        while (beginDate < endDate) {
          beginDate = new Date(beginDate.setMonth(beginDate.getMonth() + 1))
          monthBetween.push(`${formatDate(beginDate, 'yyyy-MM')}`)
        }
      }
      this.thedate = monthBetween
      this.tabledata()
    },
    // 折线图
    drawChart () {
      let myChart = this.$echarts.init(document.getElementById('station'))
      myChart.clear()
      myChart.setOption({
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['邮件营销', '联盟广告', '视频广告', '直接访问', '搜索引擎']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '邮件营销',
            type: 'line',
            stack: '总量',
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: '联盟广告',
            type: 'line',
            stack: '总量',
            data: [220, 182, 191, 234, 290, 330, 310]
          },
          {
            name: '视频广告',
            type: 'line',
            stack: '总量',
            data: [150, 232, 201, 154, 190, 330, 410]
          },
          {
            name: '直接访问',
            type: 'line',
            stack: '总量',
            data: [320, 332, 301, 334, 390, 330, 320]
          },
          {
            name: '搜索引擎',
            type: 'line',
            stack: '总量',
            data: [820, 932, 901, 934, 1290, 1330, 1320]
          }
        ]
      })
    },
    exportdata () {
      this.$store.dispatch(monitorTypes.EXPORT_RAINSTATIS_MONTHLY, {
        sID: this.sID,
        sTID: this.sTID,
        beginDate: this.beginDate,
        endDate: this.endDate,
        monthType: 'total',
        mainStation: true
      }).then(data => {
        window.location.href = this.Global.basePath + data.data
        // window.location.href
      })
    }
  },
  created () {
    this.getdate()
    this.monthselect()
  },
  mounted () {
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      let countryListDiv = document.getElementsByClassName('countryList')
      this.$refs['yuliang'].style.height = (contentDiv[0].offsetHeight - countryListDiv[0].offsetHeight - 45) + 'px'
      let selectDiv = document.getElementsByClassName('select')
      this.height = this.$refs['yuliang'].offsetHeight - selectDiv[0].offsetHeight - 20
    })
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped>
</style>
<style scoped>
.yuliang >>> .el-date-editor.el-input,
.yuliang >>> .el-date-editor.el-input__inner{
  width: 150px;
}
#station{
    width: 500px;
    height: 300px;
  }
</style>
<style lang="less" scoped>
  /* 优化表格样式 */
 .plTableBox /deep/ .elx-table{
  text-align: center !important;
  font-family: Microsoft YaHei UI !important;
  font-size: 15px !important;
  color: #666 !important;
  .elx-table--header-wrapper thead tr {
    background: #F5F7FA !important;
  }
}
/deep/ .elx-table tr:nth-child(even) {
  background: #eaf1fa !important;
}
</style>
